module.exports = __webpack_public_path__ + "static/media/sedan-white-active.a7fef8dc.png";